import { createFileRoute, redirect } from '@tanstack/react-router';

import { PerformanceDashboardPage } from '~pages/performance-dashboard/ui';
import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/performance-dashboard')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: PerformanceDashboardPage,
});
